// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-bell-floating {
  position: fixed;
  top: 18px;
  right: 18px;
  z-index: 2000;
}
.notification-bell {
  cursor: pointer;
  position: relative;
}
.notification-bell i {
  font-size: 1.7rem;
  color: #333;
}
.notification-dot {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 10px;
  height: 10px;
  background: #ff9800;
  border-radius: 50%;
  border: 2px solid #fff;
}
.notification-dropdown {
  position: absolute;
  right: 0;
  top: 40px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  border-radius: 16px;
  min-width: 370px;
  max-width: 400px;
  padding: 1.2rem 1.3rem 0.5rem 1.3rem;
  z-index: 100;
  border: none;
}
.notification-dropdown h5 {
  font-weight: bold;
  font-size: 1.35rem;
  margin-bottom: 1.2rem;
  letter-spacing: -0.5px;
}
.notification-list {
  max-height: 220px;
  overflow-y: auto;
  margin-bottom: 0.5rem;
  padding-right: 4px;
  /* Opcional: mejora el scroll visual */
  scrollbar-width: thin;
  scrollbar-color: #ccc #f5f5f5;
}
.notification-list::-webkit-scrollbar {
  width: 6px;
}
.notification-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 6px;
}
.notification-list::-webkit-scrollbar-track {
  background: #f5f5f5;
}
.notification-card {
  background: #fff;
  border-radius: 14px;
  border: none;
  box-shadow: none;
  padding: 0.7rem 0.7rem 0.7rem 0.7rem;
  margin-bottom: 0.7rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  min-height: 56px;
}
.notification-card.read {
  background: #f8f8f8;
  opacity: 0.7;
}
.notification-card:hover {
  background: #fef6e3;
}
.notification-content {
  display: flex;
  align-items: center; /* Centra verticalmente */
  gap: 14px;           /* Espacio entre icono y texto */
}
.notification-content i {
  font-size: 2.1rem; /* tamaño base para todos los iconos */
  color: #222;
}
.notification-content i.big-icon {
  font-size: 1.5rem; /* aún más grande para bi-building y similares */
}
.notification-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 36px;
}
.notification-icon i {
  font-size: 2rem;
  color: #222;
}
.notification-icon-img {
  display: block;
  margin: 0;
  align-self: center;
  width: 18px;
  height: 18px;
}
.notification-title {
  font-weight: 500;
  /* font-size: 1.18rem; */
  font-size: 1rem;
  margin-bottom: 2px;
  line-height: 1.2;
  color: #222;
}
.notification-desc {
  font-size: 0.75rem;
  color: #888;
  margin-bottom: 0;
  line-height: 1.2;
  margin-top: 2px;
}
.notification-actions {
  display: flex;
  align-items: flex-start;
  margin-left: 10px;
  margin-top: 2px;
}

 .notification-actions input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  background-color: #E0E0E0;
  border: 2px solid #bbb;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  transition: background 0.2s, border 0.2s;
}

.notification-actions input[type="radio"]:checked {
  background-color: #fff;
  border: 2px solid #ff9800;
}

.notification-actions input[type="radio"]:checked::after {
  content: '';
  position: absolute;
  top: 5px;
  left: 5px;
  width: 10px;
  height: 10px;
  background-color: #ff9800;
  border-radius: 50%;
}

.notification-footer {
  padding-top: 0.5rem;
  border-top: 1px solid #eee;
  font-size: 1.05rem;
  color: #888;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.notification-footer input[type="checkbox"] {
  accent-color: #E0E0E0;
  margin-right: 0; /* elimina el espacio extra */
}
.notification-footer label {
  display: flex;
  align-items: center;
  gap: 3px; /* antes 8px, ahora más pegado */
}

.text-muted {
  font-size: 0.8rem !important;     
}


.notification-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #aaa;
  font-size: 1.1rem;
  padding: 1.5rem 0 1rem 0;
}
.notification-empty svg {
  display: block;
  margin: 0 auto;
}
@media (max-width: 600px) {
  .notification-bell-floating {
    top: 10px;
    right: 10px;
  }
  .notification-dropdown {
    min-width: 95vw;
    max-width: 98vw;
    right: 0;
    left: auto;
    padding: 1rem 0.5rem 0.5rem 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,sCAAsC;EACtC,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB,EAAE,yBAAyB;EAC9C,SAAS,YAAY,gCAAgC;AACvD;AACA;EACE,iBAAiB,EAAE,sCAAsC;EACzD,WAAW;AACb;AACA;EACE,iBAAiB,EAAE,gDAAgD;AACrE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;CAEC;EACC,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,qBAAqB;EACrB,eAAe,EAAE,6BAA6B;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,gCAAgC;AAC5C;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,eAAe;IACf,eAAe;IACf,QAAQ;IACR,UAAU;IACV,kCAAkC;EACpC;AACF","sourcesContent":[".notification-bell-floating {\n  position: fixed;\n  top: 18px;\n  right: 18px;\n  z-index: 2000;\n}\n.notification-bell {\n  cursor: pointer;\n  position: relative;\n}\n.notification-bell i {\n  font-size: 1.7rem;\n  color: #333;\n}\n.notification-dot {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  width: 10px;\n  height: 10px;\n  background: #ff9800;\n  border-radius: 50%;\n  border: 2px solid #fff;\n}\n.notification-dropdown {\n  position: absolute;\n  right: 0;\n  top: 40px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.15);\n  border-radius: 16px;\n  min-width: 370px;\n  max-width: 400px;\n  padding: 1.2rem 1.3rem 0.5rem 1.3rem;\n  z-index: 100;\n  border: none;\n}\n.notification-dropdown h5 {\n  font-weight: bold;\n  font-size: 1.35rem;\n  margin-bottom: 1.2rem;\n  letter-spacing: -0.5px;\n}\n.notification-list {\n  max-height: 220px;\n  overflow-y: auto;\n  margin-bottom: 0.5rem;\n  padding-right: 4px;\n  /* Opcional: mejora el scroll visual */\n  scrollbar-width: thin;\n  scrollbar-color: #ccc #f5f5f5;\n}\n.notification-list::-webkit-scrollbar {\n  width: 6px;\n}\n.notification-list::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 6px;\n}\n.notification-list::-webkit-scrollbar-track {\n  background: #f5f5f5;\n}\n.notification-card {\n  background: #fff;\n  border-radius: 14px;\n  border: none;\n  box-shadow: none;\n  padding: 0.7rem 0.7rem 0.7rem 0.7rem;\n  margin-bottom: 0.7rem;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  min-height: 56px;\n}\n.notification-card.read {\n  background: #f8f8f8;\n  opacity: 0.7;\n}\n.notification-card:hover {\n  background: #fef6e3;\n}\n.notification-content {\n  display: flex;\n  align-items: center; /* Centra verticalmente */\n  gap: 14px;           /* Espacio entre icono y texto */\n}\n.notification-content i {\n  font-size: 2.1rem; /* tamaño base para todos los iconos */\n  color: #222;\n}\n.notification-content i.big-icon {\n  font-size: 1.5rem; /* aún más grande para bi-building y similares */\n}\n.notification-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n  min-height: 36px;\n}\n.notification-icon i {\n  font-size: 2rem;\n  color: #222;\n}\n.notification-icon-img {\n  display: block;\n  margin: 0;\n  align-self: center;\n  width: 18px;\n  height: 18px;\n}\n.notification-title {\n  font-weight: 500;\n  /* font-size: 1.18rem; */\n  font-size: 1rem;\n  margin-bottom: 2px;\n  line-height: 1.2;\n  color: #222;\n}\n.notification-desc {\n  font-size: 0.75rem;\n  color: #888;\n  margin-bottom: 0;\n  line-height: 1.2;\n  margin-top: 2px;\n}\n.notification-actions {\n  display: flex;\n  align-items: flex-start;\n  margin-left: 10px;\n  margin-top: 2px;\n}\n\n .notification-actions input[type=\"radio\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  background-color: #E0E0E0;\n  border: 2px solid #bbb;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  cursor: pointer;\n  position: relative;\n  transition: background 0.2s, border 0.2s;\n}\n\n.notification-actions input[type=\"radio\"]:checked {\n  background-color: #fff;\n  border: 2px solid #ff9800;\n}\n\n.notification-actions input[type=\"radio\"]:checked::after {\n  content: '';\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  width: 10px;\n  height: 10px;\n  background-color: #ff9800;\n  border-radius: 50%;\n}\n\n.notification-footer {\n  padding-top: 0.5rem;\n  border-top: 1px solid #eee;\n  font-size: 1.05rem;\n  color: #888;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n.notification-footer input[type=\"checkbox\"] {\n  accent-color: #E0E0E0;\n  margin-right: 0; /* elimina el espacio extra */\n}\n.notification-footer label {\n  display: flex;\n  align-items: center;\n  gap: 3px; /* antes 8px, ahora más pegado */\n}\n\n.text-muted {\n  font-size: 0.8rem !important;     \n}\n\n\n.notification-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: #aaa;\n  font-size: 1.1rem;\n  padding: 1.5rem 0 1rem 0;\n}\n.notification-empty svg {\n  display: block;\n  margin: 0 auto;\n}\n@media (max-width: 600px) {\n  .notification-bell-floating {\n    top: 10px;\n    right: 10px;\n  }\n  .notification-dropdown {\n    min-width: 95vw;\n    max-width: 98vw;\n    right: 0;\n    left: auto;\n    padding: 1rem 0.5rem 0.5rem 0.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
